import React, { useEffect, useState } from "react";
import { keyEntry, project } from "../../../system/types/project/project";
import { initialProject } from "../../../system/initial/project";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { EntryTranslation } from "./EntryTranslation";

interface props {
    groupId: string,
}

const ListTranslations = (props: props) => {

    const [projectData, setProjectData] = useState<project>(initialProject);

    const [groupKey, setGroupKey] = useState<string>('');
    const [listEntries, setListEntries] = useState<keyEntry[]>([]);

    useSelector((state: RootState) => {
        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }
    });


    useEffect(() => {
        projectData.groups.forEach((group) => {
            if (group.uniqueId === props.groupId) {
                setGroupKey(group.key);
                setListEntries(group.entries);
            }
        });

    }, [projectData, props.groupId]);


    return (<>
        {listEntries.map((entry) => (
            <div key={entry.uniqueId}><EntryTranslation 
                keyEntry={entry}
                groupId={props.groupId}
                groupKey={groupKey}
            ></EntryTranslation></div>
        ))}
    </>);
};

export { ListTranslations };
